<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Customer Feedbacks<br>  <span>{{type}}</span></h1>
        </div>
    </div><!-- Develop this div appropriately -->
    <div class="container">
        <div class="table">
            <div class="table-header">
                <div class="td-user_id">
                    <span>User_Id</span>
                </div>
                <div class="td-Comp">
                    <span>Complain</span>
                </div>
            </div>
            <div class="spacer-height">

            </div>
            <div class="table-container">
                <button
                    *ngFor="let customercare of customercare | paginate: { itemsPerPage: 10, currentPage: 1 }; let i = index;"
                    class="table-body" (click)="buttonPressed()">
                    <div class="td-user_id">
                        <span>{{customercare.UID}}</span>
                    </div>
                    <div class="td-comp">
                        <!-- <span>{{employee.phone_no}}</span> -->
                        <span>{{customercare.complaint}}</span>
                    </div>
                </button>
            </div>

        </div>
    </div>
</div>